import { useNavigate } from "react-router-dom";
import { useState, useRef } from "react";
import {
  ArrowBack
} from "@mui/icons-material";
import {
  Box,
  Container,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  IconButton,
  Tab, 
  Tabs,
} from "@mui/material";
import About from "./About";
import Terms from "./Terms";
import Faq from "./Faq";
import AntiScam from "./AntiScam";
import KYCVerification from "./KYCVerification";
import Rules from "./Rules";
import ResponsibleGaming from "./ResponsibleGaming";

import { useTranslation } from "react-i18next";

const InfoCenter = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const rawTitle = t("aboutus.about.title");
  const plainTitle = rawTitle.replace(/<\/?[^>]+(>|$)/g, "");
  const [selectedTab, setSelectedTab] = useState(0);

  const sections = [
    { id: "about-us", label: t("footer.aboutus") ,component : <About/>},
    { id: "terms", label: t("footer.t&c"),component : <Terms/> },
    { id: "rules", label: t("footer.bettingrules"),component : <Rules/>  },
    { id: "faq", label: t("footer.faq"),component : <Faq/>  },
    { id: "responsible", label: t("footer.responsiblegaming"),component : <ResponsibleGaming/>  },
    { id: "kyc", label: t("footer.kycverification"),component : <KYCVerification/>  },
    { id: "antiscam", label: t("footer.antiscam") ,component : <AntiScam/> },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };


  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    scrollToSection(sections[newValue].id);
  };

  return (
    <Box pb={10}>
      {mobileView && (
        <>
          <Grid container justify="center" pt={1} pb={5}>
          </Grid>
          <Box sx={{ bgcolor: "background.secondarypaper",  top: 0, zIndex: 10, pt:5 }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Page Sections"
          textColor="primary"
          indicatorColor="primary"
          sx={{
            "& .MuiTabs-indicator": { display: "none" }, // Hide default indicator
          }}
        >
          {sections.map((section, index) => (
            <Tab key={section.id} 
            label={section.label} 
            sx={{
                color: process.env.REACT_APP_COLOR_TEXT || 'white',
                border: `2px solid ${process.env.REACT_APP_COLOR_TEXT || 'white'}`,
                borderRadius: "20px",
                mx: 1, // Margin between tabs
                px: 2, // Padding inside tab
                py: 1,
                textTransform: "none",
                whiteSpace: "nowrap", // Prevent text from wrapping
               
                fontWeight: 600,
                "&.Mui-selected": {
                  bgcolor: "white",
                  color: theme.palette.primary.main, // Change text color on select
                },
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.2)", // Slight hover effect
                },
              }}/>
          ))}
        </Tabs>
      </Box>
        </>
      )}
      <>
        <Container mt={mobileView ? 0 : null}>
        <Box py={!mobileView ? 4 : 0}>
        {sections[selectedTab].component}
          {/* <About/>
          <Terms/> */}
        </Box>
        </Container>
      </>
    </Box>
  );
};

export default InfoCenter;
